/* eslint-disable import/prefer-default-export */
import { getCookie } from '@clearscore/helpers.cookies';

import * as internalIdentityActionTypes from '../internal-identity.types';

const initialState = {
    session: {
        idToken: getCookie('idToken') || null,
        accessToken: getCookie('accessToken') || null,
        loggingOut: false,
    },
    config: null,
};

export default ({ reducers }) => (rawState = initialState, action) => {
    const { type, payload } = action;
    const state = reducers.domain(rawState, action);
    switch (type) {
        case internalIdentityActionTypes.SET_SESSION:
            return {
                ...state,
                session: {
                    ...state.session,
                    ...payload,
                },
            };
        case internalIdentityActionTypes.DELETE_SESSION:
            return {
                ...state,
                session: {
                    ...state.session,
                    loggingOut: true,
                },
            };
        case internalIdentityActionTypes.SET_CONFIG:
            return {
                ...state,
                config: payload,
            };
        default:
            return state;
    }
};
